import { useEffect } from "react";
import { useFormikContext } from "formik";
function SubmitOnValueChange({ formState }) {
  const { submitForm, dirty, touched, isValid, values } = useFormikContext();
  useEffect(() => {
    submitForm();
  }, [values]);
  useEffect(() => {
    const formTouched = Object.values(touched).some((fieldTouched) => fieldTouched);
    formState({
      isValid,
      touched: formTouched,
      dirty
    });
  }, [isValid, dirty, touched, formState]);
  return null;
}
export default SubmitOnValueChange;
